<template>
  <div>
    <list
      row-key="RecordId"
      ref="list"
      unit="轮播图"
      :expand-all-row="true"
      :page="page"
      :query-params="params"
      :show-checkbox="$permission.canDel()"
      :show-query="showQuery"
      :get-data-func="api.list"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="图片名称">
          <el-input
            v-model="params.PhotoName"
            placeholder="请输入图片名称"
            clearable
          />
        </el-form-item>

        <el-form-item label="状态">
          <el-select v-model="params.State" placeholder="请选择状态" clearable>
            <el-option label="启用" :value="1"></el-option>
            <el-option label="停用" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属栏目">
          <el-select
            v-model="params.BelongColumn"
            placeholder="请选择所属栏目"
            clearable
            ><el-option label="首页" :value="1"></el-option>
            <el-option label="资源广场" :value="2"></el-option>
            <el-option label="项目招商" :value="3"></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column
          prop="OrderId"
          label="序号"
          align="center"
          width="60"
        />
        <el-table-column prop="BelongColumn" label="所属栏目">
          <template slot-scope="{ row }">
            <span v-if="row.BelongColumn == 1">首页</span>
            <span v-if="row.BelongColumn == 2">资源广场</span>
            <span v-if="row.BelongColumn == 3">项目招商</span>
          </template>
        </el-table-column>
        <el-table-column prop="PhotoName" label="图片名称" />

        <el-table-column label="图片" align="center" width="125px">
          <template slot-scope="{ row }">
            <el-image
              v-if="row.PhotoAddress"
              :src="'/api' + row.PhotoAddress"
              style="width: 100px; margin-top: 8px"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="State" width="80px" label="状态" align="center">
          <template slot-scope="{ row }">
            <el-tag type="success" v-if="row.State == 1">启用</el-tag>
            <el-tag type="danger" v-else>停用</el-tag>
          </template>
        </el-table-column>

        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
  <script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import businessSelect from "@/components/shop/business/select";

export default {
  mixins: [listMixin],
  components: { list, businessSelect },
  data() {
    return {
      api: require("@/api/store/loopphoto").default,
      params: {
        PhotoName: "",
        BelongColumn: null,
        State: null,
      },
    };
  },
  methods: {
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>